<template>
  <div class="find-location-page">
    <v-navigation-drawer v-model="drawer" absolute class="recent-drawer">
      <v-list class="pa-1">
        <v-list-item tag="div">
          <v-list-item-content>
            <v-list-item-title>Recent locations</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click.stop="drawer = !drawer">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-list class="pt-0" dense>
        <v-divider light></v-divider>

        <v-list-item data-cy="authComponentAccessFindLocationBtn" v-for="item in recentLocation" :key="item.code"
          class="py-2" @click="setLocation(item)">
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle v-html="item.code"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <main class="find-location-main">
      <section class="find-location-card">
        <header class="find-location-heading">
          <v-img alt="On the Clock Now" class="find-location-logo" contain src="../../../assets/fullLogo.png"
            transition="scale-transition" width="210" />
          <span class="find-location-icon"><v-icon>mdi-map-marker-radius-outline</v-icon></span>
          <small>Admin panel</small>
          <h1>Find your location</h1>
          <p>Enter the location code provided by your organization.</p>
        </header>
        <div class="find-location-form">
          <label class="field-label">Location details</label>
          <v-text-field label="Location Code" type="tel" outlined dense hide-details clearable @keyup.enter="checkLocationCode"
            prepend-inner-icon="mdi-map-marker-outline" v-model="locationCode"></v-text-field>
          <v-text-field label="Name" outlined hide-details clearable dense v-model="deviceName"></v-text-field>
          <v-btn class="location-submit" color="primary" rounded large block @click="checkLocationCode">
            Continue <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
          <v-btn class="recent-button" text block @click.stop="drawer = !drawer">
            <v-icon left>mdi-history</v-icon> Recent locations
          </v-btn>
          <div class="signup-link">
            Don't have an account?
            <button type="button" data-cy="loginSignUp" @click="openSignUp">Sign up</button>
          </div>
        </div>
      </section>
    </main>

    <!-- <v-footer app>
      <v-card-text>
        <span>Start Screen</span>
        <v-select
          :items="place"
          v-model="selectedPlace"
          item-text="name"
          hide-details
          outlined
          solo
          dense
        ></v-select>
      </v-card-text>
    </v-footer> -->
  </div>
</template>

<script>
import("../../../assets/logo.png");
import authService from "@/modules/Authentication/service.js";
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "locationCode-view",
  data() {
    return {
      place: ["Time Clock", "Admin Panel"],
      selectedPlace: "Admin Panel",
      drawer: false,
      recentLocation: [],
      locationCode: null,
      deviceCode: null,
      deviceName: null,
      location: null,
    };
  },
  watch: {
    selectedPlace(val) {
      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}selectedScreen`,
        val
      );
    },
  },
  created() {
    // console.log("dfdfasd", process.env.VUE_APP_STORAGE_PREFIX);
    localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);

    const selectedScreen = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}selectedScreen`
    );
    // console.log('selectedScreen', selectedScreen)
    if (selectedScreen) this.selectedPlace = selectedScreen;
    if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`)) {
      this.locationCode = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}code`
      );
      this.deviceName = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}deviceName`
      );
      localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`);
    } else {
      console.log(
        "this.locationCode",
        localStorage.getItem("csp4_terminal_code")
      );
      this.locationCode = localStorage.getItem("csp4_terminal_code");
      this.deviceName = "phone";
    }
    this.recentLocation = JSON.parse(
      localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}recentLocation`
      )
    );
    if (!this.recentLocation) this.recentLocation = [];
  },
  methods: {
    openSignUp() {
      console.log("open sign up");
      this.$router.push({ path: "/signUp" });
    },
    setLocation(location) {
      this.locationCode = location.code;
      this.checkLocationCode();
    },
    async setRecentLocation(location) {
      let found = true;
      if (this.recentLocation.length !== 0) {
        await Promise.all(
          this.recentLocation.map((row) => {
            if (row.code === location.code) {
              found = false;
            }
          })
        );
      }

      if (found) {
        this.recentLocation.push({ name: location.name, code: location.code });
      }

      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}recentLocation`,
        JSON.stringify(this.recentLocation)
      );
    },
    randomString(length, chars) {
      let result = "";
      for (let i = length; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)];
      }
      return result;
    },
    checkLocationCode() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.error("Missing Fields", { timeout: 2000 });
      } else {
        authService
          .getLocation(this.locationCode)
          .then((response) => {
            this.location = response.data;
            this.setRecentLocation(this.location);
            localStorage.setItem(
              `${process.env.VUE_APP_STORAGE_PREFIX}location`,
              JSON.stringify(this.location)
            );

            localStorage.setItem(
              `${process.env.VUE_APP_STORAGE_PREFIX}code`,
              this.locationCode
            );
            localStorage.setItem(
              `${process.env.VUE_APP_STORAGE_PREFIX}deviceName`,
              this.deviceName
            );

            // localStorage.setItem(
            //   `${process.env.VUE_APP_STORAGE_PREFIX}selectedScreen`,
            //   this.selectedPlace
            // );

            this.$router.push({ name: "authentication-employee-login" });

            // if (this.selectedPlace === "Time Clock") {
            //   this.$router.push({ name: "clockInOut" });
            // } else {
            //   this.$router.push({ name: "authentication-employee-login" });
            // }

            // this.$router.push({
            //   path: "login",
            //   name: "login",
            //   params: {
            //     ...this.$route.query,
            //     locationInstance: {
            //       code: this.locationCode,
            //       deviceName: this.deviceName,
            //       deviceCode: this.deviceCode,
            //       location: this.location,
            //     },
            //   },
            // });
          })
          .catch((error) => {
            if (error) {
              switch (error.status) {
                case 404:
                  this.$swal("Location", "Code Not Found", "error");
                  break;
                default:
                // do nothing
              }
            }
          });
      }
    },
    // submit() {
    //   if (this.locationCode && this.deviceName) {
    //     localStorage.setItem(
    //       `${process.env.VUE_APP_STORAGE_PREFIX}code`,
    //       this.locationCode
    //     );
    //     localStorage.setItem(
    //       `${process.env.VUE_APP_STORAGE_PREFIX}deviceName`,
    //       this.deviceName
    //     );
    //   }
    //   this.$router.push({
    //     name: "login",
    //     params: {
    //       locationCode: this.locationCode,
    //       deviceName: this.deviceName,
    //     },
    //   });
    // },
  },
  mixins: [validationMixin],
  validations: {
    deviceName: {
      required,
    },
    locationCode: {
      required,
    },
  },
};
</script>

<style scoped>
.find-location-page {
  background: radial-gradient(circle at 72% 12%, rgba(37, 99, 235, 0.13), transparent 34%), var(--v-background-base);
  color: var(--v-textPrimary-base);
  min-height: 100vh;
}

.find-location-main {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: 28px 16px;
}

.find-location-card {
  background: var(--v-surface-base);
  border: 1px solid var(--v-border-base);
  border-radius: 24px;
  box-shadow: 0 22px 60px rgba(4, 15, 30, 0.2);
  max-width: 500px;
  overflow: hidden;
  width: 100%;
}

.find-location-heading {
  align-items: center;
  border-bottom: 1px solid var(--v-border-base);
  display: flex;
  flex-direction: column;
  padding: 26px 24px 20px;
  text-align: center;
}

.find-location-logo { margin-bottom: 20px; }
.find-location-icon {
  align-items: center;
  background: rgba(96, 165, 250, 0.13);
  border: 1px solid rgba(96, 165, 250, 0.24);
  border-radius: 15px;
  display: flex;
  height: 48px;
  justify-content: center;
  margin-bottom: 12px;
  width: 48px;
}
.find-location-icon .v-icon { color: var(--v-primary-base); }
.find-location-heading small {
  color: var(--v-primary-base);
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.11em;
  text-transform: uppercase;
}
.find-location-heading h1 { font-size: 1.5rem; margin: 3px 0 4px; }
.find-location-heading p { color: var(--v-textSecondary-base); font-size: 0.78rem; margin: 0; }
.find-location-form { padding: 22px 24px 20px; }
.field-label { display: block; font-size: 0.72rem; font-weight: 750; margin-bottom: 8px; }
.find-location-form ::v-deep .v-input__slot { background: var(--v-surfaceMuted-base) !important; }
.find-location-form ::v-deep .v-text-field + .v-text-field { margin-top: 14px; }
.location-submit { font-weight: 750; margin-top: 20px; text-transform: none; }
.recent-button { color: var(--v-textSecondary-base) !important; margin-top: 6px; text-transform: none; }
.signup-link { border-top: 1px solid var(--v-border-base); color: var(--v-textSecondary-base); font-size: 0.75rem; margin-top: 12px; padding-top: 16px; text-align: center; }
.signup-link button { color: var(--v-primary-base); font: inherit; font-weight: 750; }
.recent-drawer { background: var(--v-surface-base) !important; color: var(--v-textPrimary-base); }
.recent-drawer ::v-deep .v-list { background: transparent !important; }

@media (max-width: 600px) {
  .find-location-main { align-items: flex-start; padding-top: 18px; }
  .find-location-card { border-radius: 18px; }
  .find-location-heading { padding: 22px 18px 17px; }
  .find-location-form { padding: 18px; }
}
</style>

<style scoped>
.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  /* Make sure the container takes full height */
}
</style>
